/* eslint-disable no-unused-expressions */

import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import { plural } from '@cian/utils/lib/shared/plural';
import * as React from 'react';

import { ElementInViewport } from '../../common/components/elementInViewport';
import { Link } from '../../common/components/link';
import { flat, suburban } from './constants';
import * as styles from './index.css';
import { suburbanTrackClick, suburbanTrackView, trackClick, trackView } from './tracking';

export interface ISimilarOffersLinkProps {
  similarOffersCount: number | null;
  similarOffersLink: string | null;
  kpId?: number | null;
}

export class SimilarOffersLink extends React.Component<ISimilarOffersLinkProps, {}> {
  public render() {
    const { similarOffersCount, similarOffersLink, kpId } = this.props;

    if (!similarOffersCount || !similarOffersLink) {
      return null;
    }

    const correctOffersCount = similarOffersCount - 1;

    if (kpId && correctOffersCount < 1) {
      return null;
    }

    return (
      <ElementInViewport
        onChange={isVisible => {
          if (isVisible) {
            kpId ? suburbanTrackView(kpId) : trackView();
          }
        }}
      >
        <div className={styles['container']}>
          <Link
            className={styles['link']}
            href={similarOffersLink}
            target="_blank"
            onClick={() => (kpId ? suburbanTrackClick(kpId) : trackClick())}
          >
            {kpId
              ? `${numberToPrettyString(correctOffersCount)} ${plural(correctOffersCount, suburban)} в этом КП`
              : `${numberToPrettyString(similarOffersCount)} ${plural(similarOffersCount, flat)} на других этажах`}
          </Link>
        </div>
      </ElementInViewport>
    );
  }
}
